var NotificationType;
(function (NotificationType) {
    NotificationType["TOAST"] = "TOAST";
    NotificationType["MODAL"] = "MODAL";
})(NotificationType || (NotificationType = {}));
const isToastNotification = (notification) => notification.type === NotificationType.TOAST;
const isModalNotification = (notification) => notification.type === NotificationType.MODAL;
export { isModalNotification, isToastNotification };
